import * as React from "react";
import Button from "@mui/material/Button";
import {
  Dialog,
  Box,
  Typography,
  Stack,
  DialogContentText,
  DialogContent,
} from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import Loader from "./../../components/Loader";
import Slide from "@mui/material/Slide";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { getBalance } from "../../asyncAction/asyncBalance";

import {
  isEmpty,
  getErrorString,
  checkExtension,
  hasPremium,
} from "../../constants/function";
import ApiService from "../../services/api-service";
import notifier from "../Notifier";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useTranslation } from "react-i18next";
import { useTheme as useAppTheme } from "../../context/ThemeContext";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ConfirmPlayListNft(props) {
  const { t } = useTranslation("common");
  const { getCurrentBranding } = useAppTheme();
  const brandName = getCurrentBranding()?.appName || "SIKI";
  const [platform, setPlatform] = React.useState("Hedera");
  const dispatch = useDispatch();
  const [currency, setCurrecy] = React.useState("siki");
  const history = useHistory();
  const { bal, hbar } = useSelector((state) => state.balance);
  const [loading, setLoading] = React.useState(false);
  const [amount, setAmount] = React.useState(0);
  const [inUsd, setInUsd] = React.useState(null);
  const [charge, setCharge] = React.useState({});
  const [discountString, setDiscountString] = React.useState("");
  const isPremium = hasPremium();
  const [confirm, setConfirm] = React.useState(false);
  const [totlaAmount, setTotlaAmount] = React.useState(0);
  const save = async () => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("title", props["form"]["title"]);
      formData.append("currency", currency);
      formData.append("private", false);
      formData.append("isExplicit", props?.data);
      formData.append(
        checkExtension(props["form"].file["name"])[0] === "gif"
          ? "GIF"
          : "thumbnailImg",
        props["form"].file
      );
      const response = await ApiService.CREATE_PLAYLIST(formData);
      const response1 = await ApiService.CREATE_PLAYLIST_NFT_V4({
        playlistId: response["result"]._id,
        currency: currency,
        private: false,
        platform: platform,
      });
      setLoading(false);
      notifier.success(t("notifier.success.toast11"));
      dispatch(getBalance());
      response["result"]["nftDetails"] = response1["result"];
      props.handleClose(response["result"], false);
    } catch (error) {
      notifier.error(getErrorString(error));
      props.handleClose(null, true);
      setLoading(false);
    }
  };
  const handleChange = (event) => {
    calculate(event.target.value);
    setCurrecy(event.target.value);
    // if (event.target.value === "siki" && bal < parseInt(amount))
    //   notifier.info("You don't have sufficient SIKI tokens to create nft.");
    // if (event.target.value === "hbar" && hbar < parseInt(amount))
    //   notifier.info("You don't have sufficient HBar tokens to create nft.");
  };
  const getChanges = async () => {
    try {
      const response = await ApiService.CHARGES();
      if (response["result"]) {
        setCharge({ ...response["result"] });
        setInUsd(1 / response["result"]["rate"]);
        let discount =
          (response["result"]["sikiOff"] / 100) *
          response["result"]["playlistNFT"];

        if (isPremium)
          discount =
            discount +
            (response["result"]["premiumOffPlaylist"] / 100) *
              response["result"]["playlistNFT"];
        const total = response["result"]["playlistNFT"] - discount;
        const premiumOffPlaylist = isPremium
          ? `${response["result"]["premiumOffPlaylist"]}% ${t("off")} +`
          : "";
        setDiscountString(
          `${response["result"]["playlistNFT"]} + ${premiumOffPlaylist}  ${
            response["result"]["sikiOff"]
          }% ${t("off")} = ${total} ${brandName} Coins`
        );
        setTotlaAmount(
          `${total.toFixed(2)} ${brandName} tokens ${t("nftPopup.text10")}`
        );
        // setAmount(total * response["result"]["rate"]);
        setAmount(
          response["result"]["playlistNFT"] * response["result"]["rate"]
        );
      }
    } catch (error) {}
  };
  const calculate = async (currency) => {
    if (charge["playlistNFT"] && currency === "siki") {
      setInUsd(1 / charge["rate"]);
      let discount = (charge["sikiOff"] / 100) * charge["playlistNFT"];

      if (isPremium)
        discount =
          discount +
          (charge["premiumOffPlaylist"] / 100) * charge["playlistNFT"];
      const total = charge["playlistNFT"] - discount;
      const premiumOffPlaylist = isPremium
        ? `${charge["premiumOffPlaylist"]}% ${t("off")} +`
        : "";
      setDiscountString(
        `${charge["playlistNFT"]} + ${premiumOffPlaylist}  ${
          charge["sikiOff"]
        }% ${t("off")} = ${total} SIKI Coins`
      );
      setTotlaAmount(`${total.toFixed(2)} SIKI tokens ${t("nftPopup.text10")}`);
      // setAmount(total * charge["rate"]);
      setAmount(charge["playlistNFT"] * charge["rate"]);
    } else if (charge["playlistNFTInHbar"] && currency === "hbar") {
      setInUsd(1 / charge["hbarValueInUsd"]);
      let discount = 0;

      if (isPremium)
        discount =
          (charge["premiumOffPlaylist"] / 100) * charge["playlistNFTInHbar"];
      const total = charge["playlistNFTInHbar"] - discount;
      const premiumOffPlaylist = isPremium
        ? `+${charge["premiumOffPlaylist"]}% ${t("off")} `
        : "";
      setDiscountString(
        !isPremium
          ? `${charge["playlistNFTInHbar"].toFixed(2)} HBar Coins`
          : `${charge["playlistNFTInHbar"].toFixed(
              2
            )}  ${premiumOffPlaylist}= ${total.toFixed(2)} HBar Coins`
      );
      setTotlaAmount(`${total.toFixed(2)} Hbar tokens ${t("nftPopup.text10")}`);
      // setAmount(total * charge["hbarValueInUsd"]);
      setAmount(charge["playlistNFTInHbar"] * charge["hbarValueInUsd"]);
    }  else if (charge["playlistNFTInMatic"] && currency === "matic") {
      setInUsd(1 / charge["maticValueInUsd"]); 
      let discount = 0;

      if (isPremium)
        discount =
          (charge["premiumOffPlaylist"] / 100) * charge["playlistNFTInMatic"];
      const total = charge["playlistNFTInMatic"] - discount;
      const premiumOffPlaylist = isPremium
        ? `+${charge["premiumOffPlaylist"]}% ${t("off")} `
        : "";
      setDiscountString(
        !isPremium
          ? `${charge["playlistNFTInMatic"].toFixed(2)} MATIC Coins`
          : `${charge["playlistNFTInMatic"].toFixed(
              2
            )}  ${premiumOffPlaylist}= ${total.toFixed(2)} MATIC Coins`
      );
      setTotlaAmount(
        `${total.toFixed(2)} MATIC tokens ${t("nftPopup.text10")}`
      );
      // setAmount(total * charge["hbarValueInUsd"]);
      setAmount(charge["playlistNFTInMatic"] * charge["maticValueInUsd"]);
    } else {
      setInUsd(1 / charge["nearValueInUsd"]); 
      let discount = 0;

      if (isPremium)
        discount =
          (charge["premiumOffPlaylist"] / 100) * charge["playlistNFTInNear"]; 
      const total = charge["playlistNFTInNear"] - discount;
      const premiumOffPlaylist = isPremium
        ? `+${charge["premiumOffPlaylist"]}% ${t("off")} `
        : "";
      setDiscountString(
        !isPremium
          ? `${charge["playlistNFTInNear"].toFixed(2)} NEAR Coins`
          : `${charge["playlistNFTInNear"].toFixed(
              2
            )}  ${premiumOffPlaylist}= ${total.toFixed(2)} NEAR Coins`
      );
      setTotlaAmount(
        `${total.toFixed(2)} NEAR tokens ${t("nftPopup.text10")}`
      );
      // setAmount(total * charge["hbarValueInUsd"]);
      setAmount(charge["playlistNFTInNear"] * charge["nearValueInUsd"]);
    }
  };
  React.useEffect(() => {
    getChanges();
  }, []);

  const showConirm = () => {
    setConfirm(true);
  };
  const handlePlatformChange = (event) => {
    setPlatform(event.target.value);
  };
  return (
    <div>
      <Dialog
        onBackdropClick={() => props.handleClose(false)}
        open={props.open}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => props.handleClose(false)}
        PaperProps={{
          style: {
            backgroundColor: "#1E1E1E",
            boxShadow: "none",
            color: "#ffffff",
            borderRadius: 16,
            margin: "0",
          },
        }}
        aria-describedby="alert-dialog-slide-description"
      >
        {confirm ? (
          <Stack style={{ backgroundColor: "#1E1E1E" }}>
            <DialogContent>
              <DialogContentText
                color="default"
                align="center"
                id="alert-dialog-slide-description"
              >
                {totlaAmount}
              </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
              <Button
                style={{ width: "150px", padding: "10px 45px !important" }}
                onClick={() => props.handleClose(null, false)}
                color="default"
              >
                {t("cancel")}
              </Button>
              <Button
                style={{ width: "150px", padding: "10px 45px !important" }}
                variant="contained"
                color="primary"
                onClick={save}
              >
                {t("confirm")}
              </Button>
            </DialogActions>
          </Stack>
        ) : (
          <Stack spacing={1} style={{ backgroundColor: "#1E1E1E" }}>
            <Stack sx={{ padding: "16px" }} spacing={1}>
              <Stack>
                <Typography color="default" className="fs-14">
                  $ {amount.toFixed(2)} {t("nftPopup.text3")}
                </Typography>
                <Typography color="default" className="fs-14">
                  {t("nftPopup.text4")}
                </Typography>
              </Stack>
              <Stack>
                <div>
                  <span
                    style={{
                      display: "flex",
                      fontSize: "16px",
                    }}
                  >
                    {t("nftPopup.text5")}
                  </span>
                </div>
                <RadioGroup
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                  aria-labelledby="currency type"
                  name="select token type"
                  value={platform}
                  onChange={handlePlatformChange}
                >
                  <FormControlLabel
                    value="Hedera"
                    control={<Radio color="primary" />}
                    label={
                      <Typography color="default" className="fs-13 _cp">
                        Hedera
                      </Typography>
                    }
                  />
                  <FormControlLabel
                    value="Polygon"
                    control={<Radio color="primary" />}
                    label={
                      <Typography color="default" className="fs-13 _cp">
                        Polygon
                      </Typography>
                    }
                  />
                  <FormControlLabel
                    value="Near"
                    control={<Radio color="primary" />}
                    label={
                      <Typography color="default" className="fs-13 _cp">
                        Near
                      </Typography>
                    }
                  />
                </RadioGroup>
              </Stack>

              {inUsd ? (
                <Typography
                  sx={{
                    color: "#F48706 !important",
                    padding: "5px",
                    fontSize: "12px !important",
                  }}
                >
                  $1 = {inUsd.toFixed(2)} {currency.toUpperCase()} Coins
                </Typography>
              ) : null}
              <Stack sx={{ backgroundColor: "#1E1E1E" }}>
                <Typography className="fs-14 fw-b" color="default">
                  {t("nftPopup.text6")}
                </Typography>

                <RadioGroup
                  sx={{
                    display: "grid",
                    justifyContent: "space-between",
                    gridTemplateColumns: "auto auto auto",
                  }}
                  aria-labelledby="currency type"
                  name="select token type"
                  value={currency}
                  onChange={handleChange}
                >
                  <FormControlLabel
                    value="siki"
                    control={<Radio color="primary" />}
                    label={
                      <Typography color="default" className="fs-13 _cp">
                        {brandName} Coins
                      </Typography>
                    }
                  />
                  <FormControlLabel
                    value="hbar"
                    control={<Radio color="primary" />}
                    label={
                      <Typography color="default" className="fs-13 _cp">
                        HBar
                      </Typography>
                    }
                  />
                  <FormControlLabel
                    value="matic"
                    control={<Radio color="primary" />}
                    label={
                      <Typography color="default" className="fs-13 _cp">
                        MATIC
                      </Typography>
                    }
                  />
                  <FormControlLabel
                    value="near"
                    control={<Radio color="primary" />}
                    label={
                      <Typography color="default" className="fs-13 _cp">
                        Near
                      </Typography>
                    }
                  />
                </RadioGroup>
              </Stack>
              <Stack spacing={1}>
                <Typography className="fs-13 " color="default">
                  {t("get")} {charge["sikiOff"]}% {t("nftPopup.text7")} {brandName}
                  Tokens
                </Typography>
                <Typography
                  className="fs-13 "
                  sx={{
                    color: "#F48706 !important",
                    fontSize: "13px !important",
                  }}
                >
                  {discountString}
                </Typography>
              </Stack>
              <DialogActions sx={{ justifyContent: "space-between" }}>
                <Button
                  sx={{ maxWidth: "150px", padding: "10px 35px" }}
                  color="default"
                  onClick={() => props.handleClose(null, false)}
                >
                  {t("cancel")}
                </Button>
                <Button
                  sx={{ maxWidth: "150px", padding: "10px 35px" }}
                  color="primary"
                  variant="contained"
                  onClick={showConirm}
                >
                  {t("continue")}
                </Button>
              </DialogActions>
            </Stack>
          </Stack>
        )}
      </Dialog>
      {loading ? <Loader /> : null}
    </div>
  );
}
